"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.voicePhraseGradient = exports.gradient = exports.buttonFocused = exports.buttonAccent = exports.accent = exports.speechBubbleReceived = exports.speechBubbleSent = exports.buttonChecked = exports.buttonCritical = exports.buttonWarning = exports.buttonSecondary = exports.buttonPrimary = exports.surfaceCard = exports.surfaceLiquid03 = exports.surfaceLiquid02 = exports.surfaceLiquid01 = exports.overlay = exports.critical = exports.warning = exports.backgroundTertiary = exports.backgroundSecondary = exports.backgroundPrimary = exports.background = exports.tertiary = exports.secondary = exports.primary = exports.text = exports.transparent = exports.blackTertiary = exports.blackSecondary = exports.blackPrimary = exports.black = exports.whiteTertiary = exports.whiteSecondary = exports.whitePrimary = exports.white = void 0;
exports.white = 'var(--plasma-colors-white)';
exports.whitePrimary = 'var(--plasma-colors-white-primary)';
exports.whiteSecondary = 'var(--plasma-colors-white-secondary)';
exports.whiteTertiary = 'var(--plasma-colors-white-tertiary)';
exports.black = 'var(--plasma-colors-black)';
exports.blackPrimary = 'var(--plasma-colors-black-primary)';
exports.blackSecondary = 'var(--plasma-colors-black-secondary)';
exports.blackTertiary = 'var(--plasma-colors-black-tertiary)';
exports.transparent = 'var(--plasma-colors-transparent)';
exports.text = 'var(--plasma-colors-text)';
exports.primary = 'var(--plasma-colors-primary)';
exports.secondary = 'var(--plasma-colors-secondary)';
exports.tertiary = 'var(--plasma-colors-tertiary)';
exports.background = 'var(--plasma-colors-background)';
exports.backgroundPrimary = 'var(--plasma-colors-background-primary)';
exports.backgroundSecondary = 'var(--plasma-colors-background-secondary)';
exports.backgroundTertiary = 'var(--plasma-colors-background-tertiary)';
exports.warning = 'var(--plasma-colors-warning)';
exports.critical = 'var(--plasma-colors-critical)';
exports.overlay = 'var(--plasma-colors-overlay)';
exports.surfaceLiquid01 = 'var(--plasma-colors-surface-liquid01)';
exports.surfaceLiquid02 = 'var(--plasma-colors-surface-liquid02)';
exports.surfaceLiquid03 = 'var(--plasma-colors-surface-liquid03)';
exports.surfaceCard = 'var(--plasma-colors-surface-card)';
exports.buttonPrimary = 'var(--plasma-colors-button-primary)';
exports.buttonSecondary = 'var(--plasma-colors-button-secondary)';
exports.buttonWarning = 'var(--plasma-colors-button-warning)';
exports.buttonCritical = 'var(--plasma-colors-button-critical)';
exports.buttonChecked = 'var(--plasma-colors-button-checked)';
exports.speechBubbleSent = 'var(--plasma-colors-speech-bubble-sent)';
exports.speechBubbleReceived = 'var(--plasma-colors-speech-bubble-received)';
exports.accent = 'var(--plasma-colors-accent)';
exports.buttonAccent = 'var(--plasma-colors-button-accent)';
exports.buttonFocused = 'var(--plasma-colors-button-focused)';
exports.gradient = 'var(--plasma-colors-gradient)';
exports.voicePhraseGradient = 'var(--plasma-colors-voice-phrase-gradient)';
//# sourceMappingURL=colors.js.map